import { LicenseEdit } from '~bank-licenses/types'

export interface ManageLicensePageProps {
  data: LicenseEdit
  returnUrl?: string
}
